import {
    setoranKasWorkshopList,
    setoranKasWorkshopDetail,
    querySetoranWorkshopList,
    search,
    pagination,
} from "./state";

const mutations = {
    setSetoranKasWorkshopList: (state, res) => {
        if (state.setoranKasWorkshopList.data !== undefined) {
            state.setoranKasWorkshopList.data.main_data = [
                ...state.setoranKasWorkshopList.data.main_data,
                ...res.data.main_data,
            ];
        } else {
            state.setoranKasWorkshopList = res;
        }
    },
    setSetoranKasWorkshopDetail: (state, res) => {
        state.setoranKasWorkshopDetail = res.data;
    },
    resetSetoranKasWorkshop: (state) => {
        state.setoranKasWorkshopList = setoranKasWorkshopList();
    },
    resetSetoranKasWorkshopDetail: (state) => {
        state.setoranKasWorkshopDetail = setoranKasWorkshopDetail();
    },

    // query
    setQuerySetoranWorkshopList: (state, query) => {
        state.querySetoranWorkshopList = query;
    },
    resetQuerySetoranWorkshopList: (state) => {
        state.querySetoranWorkshopList = querySetoranWorkshopList();
    },

    // search
    setSearch: (state, search) => {
        state.search.key = search;
    },
    resetSearch: (state) => {
        state.search = search();
    },
    setIsSearch: (state, bool) => {
        state.isSearch = bool;
    },

    // filter
    setNextPagination: (state, payload) => {
        state.pagination.length = payload.data.main_data.length;
        state.pagination.pageNumber++;
        state.pagination.offset = state.pagination.pageNumber * state.pagination.limit;
    },
    resetPagination: (state, e) => {
        state.pagination = pagination();
    },

    setScrollPosition: (state, positionY) => {
        state.scrollPosition = positionY - 100;
    },
};

export default mutations;
